import * as React from "react";
import {DATA_STATE, useUserDashboardData} from "../../contexts/UsersDashboardContext";
import {UserListContext} from "../../contexts/UserListContext";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {CardConfig, WidgetCountData} from "../../../dashboard/widgets/standard/CountsWidget";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {Display} from "../../../components/Display";
import {EmptyState, icons, infoIcons} from "@vebox/etui-core";
import {FilterCountCard} from "../../../dashboard/widgets/standard/components/FilterCountCard";
import {ACCESSES_COLOR, NOT_ACCESSES_COLOR} from "../../UserManagement";

declare var AppTranslations: AppTranslations;


const getUserUsersAccessesInTheCompany = (data: WidgetCountData[]): JSX.Element[] => {
    const COLOR_CONFIGURATIONS: CardConfig[] = [{color: ACCESSES_COLOR}, {color: NOT_ACCESSES_COLOR}];
    return data.map((value, index) =>
        <FilterCountCard
            title={value.title}
            value={value.count}
            total={value.total}
            defaultColor={COLOR_CONFIGURATIONS[index].color}
            anticlockwise={COLOR_CONFIGURATIONS[index].anticlockwise}
            reverseColors={false}
            noGreen={false}
            shortcutCode={value.shortcutCode}
            stackManager={null}
            key={index}
        />)
}

export const UsersAccessesInTheCompany: React.FC = () => {
    const {userAccessesByDayData, state} = useUserDashboardData().usersAccessesByDayState;
    const {totalUser} = React.useContext(UserListContext)
    const [isEmpty, setIsEmpty] = React.useState<boolean>(false)
    const [data, setData] = React.useState<WidgetCountData[]>([])

    React.useEffect(() => {
        if (state === DATA_STATE.loaded) {
            if (totalUser > 0) {
                setIsEmpty(false)
                setData(
                    [
                        {
                            title: AppTranslations.usersManagement.usersLogging,
                            count: totalUser - userAccessesByDayData.usersNotLogging,
                            total: totalUser,
                            shortcutCode: "accesses"
                        },
                        {
                            title: AppTranslations.usersManagement.usersNotLogging,
                            count: userAccessesByDayData.usersNotLogging,
                            total: totalUser,
                            shortcutCode: "not-accesses"
                        },
                    ]
                )
            } else {
                setIsEmpty(true)
            }
        }
    }, [state, totalUser])

    return (
        <VeBoxCard className={"Section"}>
            <VeBoxCard.Header
                title={AppTranslations.usersManagement.usersLoggingTitle}
                singleLineTitle={true}
            />
            <VeBoxCard.Body className={"detail-card"}>
                <Display isVisible={!isEmpty && state !== DATA_STATE.error}>
                    <UsersAccessesInTheCompanyCards widgetCountData={data}/>
                </Display>
                <Display isVisible={isEmpty}>
                    <div className={"vertical-align-center"}>
                        <EmptyState>
                            <EmptyState.InfoIcon
                                styles={{
                                    root: {
                                        color: "var(--empty-indicator-svg-stroke)",
                                    }
                                }}
                                glyph={infoIcons.NoContent}
                            />
                            <EmptyState.Title color="var(--empty-indicator-title-color)">{AppTranslations.noDataAvailable}</EmptyState.Title>
                            <EmptyState.SubTitle color="var(--empty-indicator-subtitle-color)">{AppTranslations.miscellaneous.checkFiltersMessage}</EmptyState.SubTitle>
                        </EmptyState>
                    </div>
                </Display>
                <Display isVisible={state === DATA_STATE.error}>
                    <EmptyState>
                        <EmptyState.Icon size={144} glyph={icons.ERROR_CIRCLE}/>
                        <EmptyState.Title color="var(--empty-indicator-title-color)">{AppTranslations.errorMessages.errorTitle}</EmptyState.Title>
                        <EmptyState.SubTitle color="inherit">
                            {AppTranslations.errorMessages.tryAgainLaterMessage}
                        </EmptyState.SubTitle>
                    </EmptyState>
                </Display>
            </VeBoxCard.Body>
        </VeBoxCard>
    )
}

interface UsersAccessesInTheCompanyCardsProps {
    widgetCountData: WidgetCountData[]
}

const UsersAccessesInTheCompanyCards: React.FC<UsersAccessesInTheCompanyCardsProps> = ({widgetCountData}) => {
    return <div className={"counts-widget cards-cart"}>
        <div className={"list-widget__content"}>
            {getUserUsersAccessesInTheCompany(widgetCountData)}
        </div>
    </div>
}